export enum Day {
	Monday = 'MONDAY',
	Tuesday = 'TUESDAY',
	Wednesday = 'WEDNESDAY',
	Thursday = 'THURSDAY',
	Friday = 'FRIDAY',
	Saturday = 'SATURDAY',
	Sunday = 'SUNDAY',
}

export const DAYS = [Day.Monday, Day.Tuesday, Day.Wednesday, Day.Thursday, Day.Friday, Day.Saturday, Day.Sunday];
